import { MobileNavigationMenu } from "./mobile-navigation-menu";
import { MobileSharedMenuItem } from "./mobile-shared-menu-item";
import { MobileSetupMenuItem } from "./mobile-setup-menu-item";
import { MobileFeatureMenuItem } from "./mobile-feature-menu-item";

export class MobileMenuItem {
    Title: string;
    TargetType: string;
    Target: string;
    Description: string;
    OpenInNewWindow: boolean;
    SubMenu: MobileMenuItem[];

    itemIndent: number;
    active: boolean;

    static fromNavigationMenuItem(item: MobileNavigationMenu): MobileMenuItem {
        const newItem: MobileMenuItem = new MobileMenuItem();
        newItem.Title = item.Title;
        newItem.TargetType = item.TargetType.toLowerCase();
        newItem.Target = item.TargetId;
        newItem.OpenInNewWindow = false;
        newItem.itemIndent = item.itemIndent;
        newItem.active = item.active;

        return newItem;
    }

    static fromSharedMenuItem(item: MobileSharedMenuItem): MobileMenuItem {
        const newItem: MobileMenuItem = new MobileMenuItem();
        newItem.Title = item.Title;
        newItem.TargetType = item.TargetType.toLowerCase();
        newItem.Target = item.Target;
        newItem.OpenInNewWindow = item.OpenInNewWindow;
        newItem.itemIndent = 0;
        newItem.active = false;

        return newItem;
    }

    static fromSetupMenuItem(item: MobileSetupMenuItem): MobileMenuItem {
        const newItem: MobileMenuItem = new MobileMenuItem();
        newItem.Title = item.Title;
        newItem.TargetType = item.TargetType.toLowerCase();
        newItem.Target = item.Target;
        newItem.OpenInNewWindow = item.OpenInNewWindow;
        newItem.itemIndent = 0;
        newItem.active = false;

        return newItem;
    }

    static fromFeaturesMenuItem(item: MobileFeatureMenuItem): MobileMenuItem {
        const newItem: MobileMenuItem = new MobileMenuItem();
        newItem.Title = item.Title;
        newItem.Description = item.Description;
        newItem.TargetType = item.TargetType.toLowerCase();
        newItem.Target = item.Target;
        newItem.OpenInNewWindow = item.OpenInNewWindow;
        newItem.itemIndent = 0;
        newItem.active = false;

        return newItem;
    }
}
